import axios from 'axios';

declare global {
    interface Window {
        axios: typeof axios;
        Echo?: any;
    }
}

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;

// Echo initialization is deferred to app-wrapper.tsx
// This avoids issues with SSR and allows proper async loading
